import React, { useState, useEffect } from "react";

const NAMES = ["Gábor", "Krisztián", "Bence", "Zoltán", "Anna", "Eszter", "Péter", "László", "Tamás", "Andrea"];
const ACTIONS = [
  (name, place) => `${name} épp most regisztrált a ${place}-ba`,
  (name, place) => `${name} aktiválta a bónuszt a ${place}-on`,
  (name, place) => `${name} most nézi a ${place} értékelését`,
];
const PLACES = ["GoldSpin Casino", "NeonBet", "LunaPlay", "GoldBet Sport", "Tipperz", "FireSpin", "DiamondBet", "MagyarSlots", "ArenaBet"];

export default function ActivityFeed() {
  const [msg, setMsg] = useState(null);
  useEffect(() => {
    const tick = () => {
      const name = NAMES[Math.floor(Math.random() * NAMES.length)];
      const place = PLACES[Math.floor(Math.random() * PLACES.length)];
      const action = ACTIONS[Math.floor(Math.random() * ACTIONS.length)];
      setMsg(action(name, place));
      setTimeout(() => setMsg(null), 5000);
    };
    const initial = setTimeout(tick, 8000);
    const interval = setInterval(tick, 22000);
    return () => {
      clearTimeout(initial);
      clearInterval(interval);
    };
  }, []);
  if (!msg) return null;
  return (
    <div className="fixed bottom-6 left-6 z-[55] hidden md:block animate-slidein" data-testid="activity-feed">
      <div className="glass-strong rounded-xl px-4 py-2.5 border border-white/10 shadow-2xl">
        <div className="flex items-center gap-2">
          <div className="relative">
            <div className="w-2 h-2 rounded-full bg-neon-green animate-pulse"></div>
            <div className="absolute inset-0 w-2 h-2 rounded-full bg-neon-green/40 animate-ping"></div>
          </div>
          <span className="text-xs text-white/80">{msg}</span>
        </div>
      </div>
    </div>
  );
}
